export enum UserRoleCategory {
  Admin = 'admin',
  Agent = 'agent',
  CorporateUser = 'corporateUser',
  Customer = 'customer',
}
